import React, { useState } from 'react'
import Header from '../category/subcategory/Header'
import accordionIcon from '../../../assets/images/menu/accordion.svg'
import "../../../scss/pages/faq.css";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HealthTips = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const [tips, setTips] = useState('health')
  const handleItemClick = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index));
  };
  const {t} = useTranslation();
  const contentObj = [
    { title: t("health_tips.title1"), content: t("health_tips.content1") },
    { title: t("health_tips.title2"), content: t("health_tips.content2") },
    { title: t("health_tips.title3"), content: t("health_tips.content3") },
    { title: t("health_tips.title4"), content: t("health_tips.content4") },
    { title: t("health_tips.title5"), content: t("health_tips.content5") },
    { title: t("health_tips.title6"), content: t("health_tips.content6") },
    { title: t("health_tips.title7"), content: t("health_tips.content7") },
    { title: t("health_tips.title8"), content: t("health_tips.content8") },
    { title: t("health_tips.title9"), content: t("health_tips.content9") },
    { title: t("health_tips.title10"),content: t("health_tips.content10") },
    { title: t("health_tips.title11"),content: t("health_tips.content11") },
    { title: t("health_tips.title12"),content: t("health_tips.content12") },
    { title: t("health_tips.title13"),content: t("health_tips.content13") },
    { title: t("health_tips.title14"),content: t("health_tips.content14") },
    { title: t("health_tips.title15"),content: t("health_tips.content15") },
    { title: t("health_tips.title16"),content: t("health_tips.content16") },
    { title: t("health_tips.title17"),content: t("health_tips.content17") },
    { title: t("health_tips.title18"),content: t("health_tips.content18") },
    { title: t("health_tips.title19"),content: t("health_tips.content19") },
    { title: t("health_tips.title20"),content: t("health_tips.content20") },
  ]

  const diseaseObj = [
    { title: t("health_initiatives.title1"), content: t("health_initiatives.content1") },
    { title: t("health_initiatives.title2"), content: t("health_initiatives.content2") },
    { title: t("health_initiatives.title3"), content: t("health_initiatives.content3") },
    { title: t("health_initiatives.title4"), content: t("health_initiatives.content4") },
    { title: t("health_initiatives.title5"), content: t("health_initiatives.content5") },
    { title: t("health_initiatives.title6"), content: t("health_initiatives.content6") },
    { title: t("health_initiatives.title7"), content: t("health_initiatives.content7") },
    { title: t("health_initiatives.title8"), content: t("health_initiatives.content8") },
    { title: t("health_initiatives.title9"), content: t("health_initiatives.content9") },
    { title: t("health_initiatives.title10"),content: t("health_initiatives.content10") },
    { title: t("health_initiatives.title11"),content: t("health_initiatives.content11") },
    { title: t("health_initiatives.title12"),content: t("health_initiatives.content12") },
    { title: t("health_initiatives.title13"),content: t("health_initiatives.content13") },
    { title: t("health_initiatives.title14"),content: t("health_initiatives.content14") },
    { title: t("health_initiatives.title15"),content: t("health_initiatives.content15") },
    { title: t("health_initiatives.title16"),content: t("health_initiatives.content16") },
    { title: t("health_initiatives.title17"),content: t("health_initiatives.content17") },
    { title: t("health_initiatives.title18"),content: t("health_initiatives.content18") }
  ]
  return (
    <>
      <Header headtitle={t('health_tips.generaltips')} />
      <div className="faqWrap">
        <div className="tipsWrap">
          <Link to='#' onClick={()=>{setTips('health')}} className={tips==='health' ? 'active': null}>{t('health_tips.healttitle')}</Link>
          <Link to='#' onClick={()=>{setTips('disease')}} className={tips==='disease' ? 'active': null}>{t('health_tips.Diseasetitle')}</Link>
        </div>
        {tips==='health'?
          <>
          {contentObj?.map((item, index) => (
            <div className="faqWrapper" key={index}>
              <div className="title" onClick={() => handleItemClick(index)}>
                <h5>{item?.title} <img src={accordionIcon} className="img-fluid" alt="" /></h5>
                {openIndex === index ? <p>{item.content}</p> : null}
              </div>
            </div>
          ))}
          </>:<>
          {diseaseObj?.map((item, index) => (
            <div className="faqWrapper" key={index}>
              <div className="title" onClick={() => handleItemClick(index)}>
                <h5>{item?.title} <img src={accordionIcon} className="img-fluid" alt="" /></h5>
                {openIndex === index ? <p>{item.content}</p> : null}
              </div>
            </div>
          ))}
          </>
        }
      </div>
    </>
  )
}

export default HealthTips
